/**
 * QR Code Element Renderer
 */

import { BaseElementRenderer, type ElementRenderContext } from './base-element-renderer';
import { QRCodePreview } from '@/components/ui/qr-code-preview';

export class QRCodeRenderer extends BaseElementRenderer {
  canRender(elementType: string): boolean {
    return elementType === 'qrcode';
  }
  
  render(context: ElementRenderContext) {
    const { element, maxElementHeight, isStretched, baseStyle, isSelected, onClick } = context;
    
    let qrWidth: string | number = '100%';
    let qrHeight: string | number = '100%';
    const maxSize = maxElementHeight || 300;
    
    if (!isStretched?.horizontal && !isStretched?.vertical) {
      const qrSize = Math.min(element.width || 150, element.height || 150, maxSize);
      qrWidth = qrSize;
      qrHeight = qrSize;
    } else if (isStretched?.horizontal && !isStretched?.vertical) {
      qrWidth = '100%';
      qrHeight = Math.min(element.height || 150, maxSize);
    } else if (!isStretched?.horizontal && isStretched?.vertical) {
      qrWidth = Math.min(element.width || 150, maxSize);
      qrHeight = '100%';
    }
    
    return (
      <div 
        style={{ 
          ...baseStyle,
          width: qrWidth,
          height: qrHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          outline: isSelected ? '2px solid #3b82f6' : 'none',
        }}
        onClick={onClick}
      >
        <QRCodePreview 
          width={typeof qrWidth === 'number' ? qrWidth : undefined} 
          height={typeof qrHeight === 'number' ? qrHeight : undefined}
          stretchHorizontal={isStretched?.horizontal}
          stretchVertical={isStretched?.vertical}
        />
      </div>
    );
  }
}
